<template>
  <aside class="logout-btn">
    <v-btn @click="logout" color="purple" dark round>
      <span class="mr-2">Salir de la app</span>
      <v-icon>exit_to_app</v-icon>
    </v-btn>
  </aside>
</template>

<script>
import auth from "@/auth";

export default {
  methods: {
    logout() {
      auth.logout();
      return this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.logout-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>